import React from "react";
import gitimage from "../../images/Github Button Web.png";

export default function Portfolio() {
  return (
    <div className="portfolio-body">
      <div className="portfolio-h1-and-line"></div>
      <h1 className="portfolio-h1">PROJECTS</h1>
      <span className="line-projects"></span>

      <div className="cards-container">
        {/* CARD 1 */}

        <div className="card-1">
          <h1 className="project-name">
            <a
              className="project-name-link"
              href="https://github.com/AndrejsGrocs"
              target="_blank"
            >
              GIT PROJECTS
            </a>{" "}
            <a href="https://github.com/AndrejsGrocs" target="_blank">
              <img className="project-git-icon" alt="" src={gitimage} />
            </a>
          </h1>
          <span className="line-card"></span>
          <h2 className="card-h2">ALL GIT PROJECTS </h2>
        </div>

        {/* CARD 2 */}

        <div className="card-2">
          <h1 className="project-name">
            <a
              className="project-name-link"
              href="https://dolphin-bank.herokuapp.com/"
              target="_blank"
            >
              DOLPHIN BANK
            </a>{" "}
            <a
              href="https://github.com/AndrejsGrocs/Dolphin-Bank-Sustainable-Investments"
              target="_blank"
            >
              <img className="project-git-icon" alt="" src={gitimage} />
            </a>
          </h1>
          <span className="line-card"></span>
          <h2 className="card-h2">BANKING APP</h2>
        </div>

        {/* CARD 3 */}

        <div className="card-2">
          <h1 className="project-name">
            <a
              className="project-name-link"
              href="https://study-gal-c1f4cd1e8c0e.herokuapp.com/"
              target="_blank"
            >
              STUDY GAL
            </a>{" "}
            <a href="https://github.com/AndrejsGrocs/Study-Gal" target="_blank">
              <img className="project-git-icon" alt="" src={gitimage} />
            </a>
          </h1>
          <span className="line-card"></span>
          <h2 className="card-h2">STUDY APP (Desktop only)</h2>
        </div>

        {/* CARD 4 */}

        <div className="card-2">
          <h1 className="project-name">
            <a
              className="project-name-link"
              href="https://www.duxsonus.com/"
              target="_blank"
            >
              DUX SONUS
            </a>{" "}
            <a
              href="https://github.com/AndrejsGrocs/Study-Gal"
              target="_blank"
            ></a>
          </h1>
          <span className="line-card"></span>
          <h2 className="card-h2">RECORD LABEL (Desktop only)</h2>
        </div>

        {/* CARD 5 */}

         <div className="card-2">
          <h1 className="project-name">
            <a
              className="project-name-link"
              href="https://powder-calculator-1cd4de144e17.herokuapp.com/"
              target="_blank"
            >
              P CALCULATOR
            </a>{" "}
            <a
              href="https://github.com/AndrejsGrocs/Study-Gal"
              target="_blank"
            ></a>
          </h1>
          <span className="line-card"></span>
          <h2 className="card-h2">POWDER CALCULATOR (Desktop only)</h2>
        </div>

        {/* CARD 6 */}

        <div className="card-6">
          <h1 className="project-name no-git-logo">
            <p
            // className='project-name-link' href='https://github.com/AndrejsGrocs'
            // target="_blank"
            >
              COMING SOON
            </p>
            {/* <a href='https://github.com/AndrejsGrocs' target="_blank">
    <img
        className="project-git-icon hidden1"
        alt=""
        src={gitimage}
      />
      </a> */}
          </h1>
          <span className="line-card"></span> 
          {/* <h2 className='card-h2'>PROJECT NAME</h2> */}
        </div>
      </div>
    </div>
  );
}
